const formatAmount = (amount) => {
    amount = Number(amount)
    const parts = amount.toFixed(2).toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
}

const formatPhoneNumber = (number) => {
    const numberStr = number.toString();
    const formattedNumber = numberStr.replace(/(\d{4})(\d{3})(\d{3})/, '$1 $2 $3');
    return formattedNumber;
}

const formatStringDate = (inputDate) => {
    const options = { year: 'numeric', month: 'short', day: '2-digit' };
    const formattedDate = new Date(inputDate).toLocaleDateString(undefined, options);
    return formattedDate;
}

const workTypeFormatChange = (workType) => {

    switch (workType) {
        case 'from_iw_amc_package_renewal':
        case 'from_ssp_amc_package_renewal':
        case 'from_amc_amc_package_renewal':
        case 'from_ow_amc_package_renewal':
            return 'AMC Package renewal'

        case 'from_iw_ssp_package_renewal':
        case 'from_amc_ssp_package_renewal':
        case 'from_ssp_ssp_package_renewal':
        case 'from_ow_ssp_package_renewal':
        case 'from_oc_ssp_package_renewal':
            return 'SSP Package renewal'

        case 'from_iw_carbon_change_without_package':
        case 'from_amc_carbon_change_without_package':
        case 'from_ssp_carbon_change_without_package':
        case 'from_ow_carbon_change_without_package':
            return 'Carbon Change without package'

        case 'from_ssp_periodical_service':
        case 'from_ow_periodical_service':
        case 'from_iw_periodical_service':
        case 'from_amc_periodical_service':
            return 'Periodical service'

        case 'from_ssp_complaint':
        case 'from_ow_complaint':
        case 'from_iw_complaint':
        case 'from_amc_complaint':
            return 'Complaint'

        default:
            return workType;
    }
}

const numberInWord = (amount) => {
    const units = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
    const teens = ['', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
    const tens = ['', 'Ten', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
    const thousands = ['', 'Thousand', 'Million', 'Billion', 'Trillion']; // Extend as needed

    function convertThreeDigits(num) {
        const numStr = num.toString();
        const [a, b, c] = numStr.padStart(3, '0').split('').map(Number);

        let result = '';
        if (a > 0) {
            result += units[a] + ' Hundred ';
        }
        if (b === 1) {
            result += teens[c] + ' ';
        } else {
            result += tens[b] + ' ' + units[c] + ' ';
        }
        return result;
    }

    function convertToWords(amount) {
        if (amount === 0) {
            return 'Zero';
        }

        const amountStr = amount.toString();
        const chunks = [];

        for (let i = amountStr.length; i > 0; i -= 3) {
            chunks.push(amountStr.slice(Math.max(0, i - 3), i));
        }

        let words = '';
        for (let i = chunks.length - 1; i >= 0; i--) {
            const chunk = parseInt(chunks[i]);
            if (chunk === 0) continue;

            words += convertThreeDigits(chunk) + thousands[i] + ' ';
        }

        return words.trim();
    }

    return convertToWords(amount);
}

const YYYYMMDDFormat = (ISOdate, symbol = '-') => {
    symbol = symbol ? symbol : ''
    const year = ISOdate?.getFullYear();
    const month = String(ISOdate.getMonth() + 1).padStart(2, '0');
    const day = String(ISOdate.getDate()).padStart(2, '0');

    return `${year}${symbol}${month}${symbol}${day}`;
}

const YYYYMMFormat = (ISOdate, symbol = '-') => {
    symbol = symbol ? symbol : ''
    const year = ISOdate?.getFullYear();
    const month = String(ISOdate.getMonth() + 1).padStart(2, '0');


    return `${year}${symbol}${month}`;
}

function convertIsoToAmPm(isoString) {
    // Parse the ISO string into a Date object
    const date = new Date(isoString);

    // Get hours, minutes, and seconds
    let hours = date.getHours();
    const minutes = date.getMinutes();

    // Format hours for AM/PM
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'

    // Pad minutes and seconds with leading zeros if needed
    const minutesStr = minutes < 10 ? '0' + minutes : minutes;


    // Combine parts
    return `${hours}:${minutesStr} ${ampm}`;
}


function decimalToNumber(value) {
    if (
        value &&
        typeof value === 'object' &&
        '$numberDecimal' in value
    ) {
        return Number(value.$numberDecimal)
    }

    return value
}

const toDecimal = (
    value,
    {
        precision = 2,
        fallback = 0,
        allowNegative = true
    } = {}
) => {
    if (value === null || value === undefined) return fallback;

    // Convert to string & clean
    let cleaned = String(value)
        .trim()
        .replace(/,/g, '')               // remove commas
        .replace(/[^\d.-]/g, '');        // remove currency & text

    if (!cleaned || cleaned === '-' || cleaned === '.') {
        return fallback;
    }

    let number = Number(cleaned);

    // Handle NaN & Infinity
    if (!Number.isFinite(number)) {
        return fallback;
    }

    // Negative handling
    if (!allowNegative && number < 0) {
        return fallback;
    }

    // Fix floating precision issue
    const factor = Math.pow(10, precision);
    return Math.round((number + Number.EPSILON) * factor) / factor;
};

const convertBillToItemGrouping = (bill) => {

    if (!bill?.bill_no) {
        return null
    }

    const groupMap = new Map()

    // Group all items
    for (const item of bill.items || []) {

        const groupId = item?.group?.id || 'NO_GROUP'

        if (!groupMap.has(groupId)) {

            groupMap.set(groupId, {
                group_type: item?.group?.type || null,
                group_id: groupId,
                group_name: item?.group?.name || 'Unknown Group',
                items: [],
                pricing: {
                    list_total: 0,
                    ledger_total: 0,
                    sub_total: 0,
                    tax_amount: 0,
                    grand_total: 0
                }
            })
        }

        const groupData = groupMap.get(groupId)

        const itemListTotal = toDecimal(decimalToNumber(item?.pricing?.list_price?.total || 0))
        const itemLedgerTotal = toDecimal(decimalToNumber(item?.pricing?.ledger_cost?.total || 0))
        const itemSubTotal = toDecimal(decimalToNumber(item?.sub_total || 0))
        const itemTaxTotal = toDecimal(decimalToNumber(item?.tax?.amount || 0))
        const itemTotal = toDecimal(decimalToNumber(item?.total || 0))

        groupData.items.push({
            item_id: item?.item_id,
            item_category: item?.item_category,
            item_type: item?.item_type,
            item_name: item?.item_name,
            product_type: item?.product_type,
            qty: item?.qty,
            unit: item?.unit,
            unit_list_price: toDecimal(decimalToNumber(item?.pricing?.list_price?.unit_price || 0)),
            unit_ledger_cost: toDecimal(decimalToNumber(item?.pricing?.ledger_cost?.unit_price || 0)),
            unit_charged_price: toDecimal(decimalToNumber(item?.pricing?.charged?.unit_price || 0)),
            tax: item?.tax,
            total: toDecimal(decimalToNumber(item?.total)),
        })

        groupData.pricing.list_total += itemListTotal
        groupData.pricing.ledger_total += itemLedgerTotal
        groupData.pricing.sub_total += itemSubTotal
        groupData.pricing.tax_amount += itemTaxTotal
        groupData.pricing.grand_total += itemTotal
    }

    // Convert map to array
    const groupedItems = Array.from(groupMap.values())

    return groupedItems

}

const convertBillToList = (bill) => {

    if (!bill?.bill_no) {
        return null
    }

    let itemListTotal = 0
    let itemLedgerTotal = 0

    const billItems = bill.items?.map((item) => {

        itemListTotal += toDecimal(decimalToNumber(item?.pricing?.list_price?.total || 0))
        itemLedgerTotal += toDecimal(decimalToNumber(item?.pricing?.ledger_cost?.total || 0))

        return {
            item_id: item?.item_id,
            item_category: item?.item_category,
            item_type: item?.item_type,
            item_name: item?.item_name,
            product_type: item?.product_type,
            qty: item?.qty,
            unit: item?.unit,
            unit_list_price: toDecimal(decimalToNumber(item?.pricing?.list_price?.unit_price || 0)),
            unit_ledger_cost: toDecimal(decimalToNumber(item?.pricing?.ledger_cost?.unit_price || 0)),
            unit_charged_price: toDecimal(decimalToNumber(item?.pricing?.charged?.unit_price || 0)),
            tax: item?.tax,
            total: toDecimal(decimalToNumber(item?.total)),
        }
    })

    return [{
        group_id: "1",
        group_name: "Items",
        group_type: 'listing',
        // Grouping
        items: billItems,
        pricing: {
            list_total: itemListTotal,
            ledger_total: itemLedgerTotal,
            sub_total: toDecimal(decimalToNumber(bill?.pricing?.subtotal)),
            tax_amount: toDecimal(decimalToNumber(bill?.pricing.tax_summary?.total_tax)),
            grand_total: toDecimal(decimalToNumber(bill?.pricing.grand_total))
        }
    }]

}

export {
    formatAmount, formatPhoneNumber, formatStringDate, workTypeFormatChange, numberInWord, YYYYMMDDFormat, convertIsoToAmPm,
    YYYYMMFormat, decimalToNumber, convertBillToItemGrouping, convertBillToList, toDecimal
}